module.exports = __webpack_public_path__ + "img/w21-b3.f22bb391.jpg";